import React, { useCallback, useState } from 'react';
import { TextField } from '@mui/material';
import { tt } from '@i18n/tt';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { ThunkGetTickets } from 'store/tickets/thunks';
import { TicketsParamsSelector } from 'store/tickets/selectors';
import { changeTicketSummary } from 'store/tickets';

import { ReactComponent as SearchIcon } from '../../../../assets/search.icon.svg';

import Button from '../../../../components/Button/Button';
import CreateTicketDialog from 'components/CreateTicketDialog';
import { ReactComponent as PlusIcon } from 'assets/add.icon.svg';

import useStyles from '../../styles';
import cx from 'classnames';

const TicketsSearch: React.FC<{
  isCreateButtonDisplay?: boolean;
  searchFieldClassName?: string;
}> = ({ isCreateButtonDisplay = true, searchFieldClassName }) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [openTicketCreationDialog, setOpenTicketCreationDialog] = useState<boolean>(false);

  const params = useAppSelector(TicketsParamsSelector);
  const dispatch = useAppDispatch();
  const classes = useStyles();

  const handleSearch = useCallback(
    (search: string) => {
      dispatch(changeTicketSummary(search));
      dispatch(ThunkGetTickets({ params: { ...params, page: 0, search } }));
    },
    [dispatch, params],
  );

  return (
    <div className={classes.searchContainer}>
      <div className={cx(classes.searchContainerFields, searchFieldClassName)}>
        <TextField
          placeholder={tt('pages.tickets.search')}
          variant="outlined"
          fullWidth
          size="small"
          value={searchValue}
          onChange={e => {
            setSearchValue(e.target.value);
          }}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              handleSearch(searchValue);
            }
          }}
          InputProps={{
            startAdornment: (
              <SearchIcon
                className={classes.searchIcon}
                onClick={() => {
                  handleSearch(searchValue);
                }}
              />
            ),
          }}
        />
      </div>

      {isCreateButtonDisplay && (
        <div>
          <Button
            text={tt('pages.tickets.createTicketButton')}
            onClick={() => {
              setOpenTicketCreationDialog(true);
            }}
            startIcon={<PlusIcon/>}fullWidth
          />
        </div>
      )}
      {openTicketCreationDialog && (
        <CreateTicketDialog
          open={openTicketCreationDialog}
          onClose={() => {
            setOpenTicketCreationDialog(false);
          }}
        />
      )}
    </div>
  );
};

export default TicketsSearch;
